/// <amd-module name="Build/ApprovalsPanel/ResourceLinks" />
import * as Constants from "Build/ApprovalsPanel/Constants";
import { CheckResource } from "Build/Client/Contracts/DataProvider";

import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";
import { IVssNavigationService } from "VSS/Platform/Navigation";

export function getResourceUrl(pageContext: IVssPageContext, resource: CheckResource, showChecksPage: boolean = false): string {
    let routeParams = {};
    let routeUrl = "";

    const view = showChecksPage ? "checks" : "";

    switch (resource.type) {
        case Constants.Resource_Environment:
            routeParams = { environmentId: resource.id, view };
            routeUrl = createUrlForRoute(pageContext, Environments_route_contribution, routeParams);
            break;
        case Constants.Resource_Queue:
            routeParams = { adminPivot: "agentqueues", queueId: resource.id, view: view };
            routeUrl = createUrlForRoute(pageContext, AdminHub_route_contribution, routeParams);
            break;
        case Constants.Resource_ServiceEndPoint:
            routeParams = { adminPivot: "adminservices", resourceId: resource.id, view: view };
            routeUrl = createUrlForRoute(pageContext, AdminHub_route_contribution, routeParams);
            break;
        case Constants.Resource_VariableGroup:
            routeParams = { itemType: "VariableGroups", view: "VariableGroupView", variableGroupId: resource.id };
            routeUrl = createUrlForRoute(pageContext, LibraryHub_route_contribution, routeParams);
            break;
        case Constants.Resource_SecureFile:
            routeParams = { itemType: "SecureFiles", view: "SecureFileView", secureFileId: resource.id };
            routeUrl = createUrlForRoute(pageContext, LibraryHub_route_contribution, routeParams);
            break;
        case Constants.Resource_Repository:
            const routeValues: { [key: string]: string } = {};
            routeValues["project"] = resource.id.split(".", 1)[0];
            routeValues["vc.GitRepositoryName"] = resource.name;
            routeUrl = createUrlForRoute(pageContext, Repository_route_contribution, routeValues);
            break;
    }

    return routeUrl;
}

export function getBuildUrl(pageContext: IVssPageContext, scopeId: string, buildId: number): string {
    const routeValues: { [key: string]: string } = {};
    routeValues["project"] = scopeId;
    routeValues["buildId"] = buildId.toString();

    return routeUrl(pageContext, BuildResultRouteId, routeValues);
}

function createUrlForRoute(pageContext: IVssPageContext, contributionId: string, routeParams: { [key: string]: string }): string {
    const currentRouteValues = getPageRouteValues(pageContext);

    let routeValues: { [key: string]: string } = { project: currentRouteValues.project, ...routeParams };
    if (currentRouteValues.team) {
        routeValues.team = currentRouteValues.team;
    }

    return routeUrl(pageContext, contributionId, routeValues);
}

function getPageRouteValues(pageContext: IVssPageContext): any {
    return pageContext
        .getService<IVssNavigationService>("IVssNavigationService")
        .getCurrentRoute()
        .routeValues;
}

//Contribution Ids for routes
const Environments_route_contribution = "ms.vss-environments-web.environments-route-with-id";
const AdminHub_route_contribution = "ms.vss-admin-web.project-admin-hub-route";
const LibraryHub_route_contribution = "ms.vss-distributed-task.hub-library-default-route";
const Repository_route_contribution = "ms.vss-code-web.files-route-git";
const BuildResultRouteId: string = "ms.vss-build-web.ci-results-hub-route";